/**
 * Created by Administrador on 26/03/2019.
 */
(function(){
    'use strict'

    angular
        .module('completeAir')
        .factory('paginationService', ['$state', function($state){
            var service = {
                getPages: getPages
            }
            return service;

            function getPages(){
                return {
                    number: 0,
                    size: 10,
                    totalElements: 0,
                    totalPages:0
                };
            }
        }]);
})();
